export const ListManager = {
  add(list, item, uidGenerator) {
    const newItem = { ...item };
    if (uidGenerator) {
      newItem._uid = uidGenerator();
    }
    list.push(newItem);
    return list.length - 1;
  },

  remove(list, index) {
    if (index >= 0 && index < list.length) {
      list.splice(index, 1);
    }
  },

  move(list, fromIndex, toIndex) {
    if (fromIndex < 0 || fromIndex >= list.length || toIndex < 0 || toIndex >= list.length) return;
    const [item] = list.splice(fromIndex, 1);
    list.splice(toIndex, 0, item);
  },

  clear(list) {
    list.splice(0, list.length);
  },
};
